import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const timelineWrapper = css`
  width: 100%;
  margin-top: 10px;
  overflow-x: scroll;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;

export const cartesianGrid = {
  strokeDasharray: '3 3',
  color: colors.gray[4],
};

export const routePeriod = css`
  fill: ${colors.gray[4]};
`;

export const noRouteLabel = css`
  > rect {
    :nth-of-type(1) {
      height: 69px;
      fill: none;
    }
    :nth-of-type(2) {
      height: 21px;
      fill: ${colors.gray[2]};
    }
  }

  > #middleLine {
    stroke: ${colors.gray[4]};
  }

  > text {
    font-size: ${fonts.size.smallest};
    font-weight: ${fonts.weight.regular};
    fill: ${colors.gray[9]};
  }
`;

export const routeLabel = css`
  > rect {
    height: 69px;
    fill: none;
  }

  > g #startEndBar {
    stroke-width: 2;
    stroke-linecap: round;
    stroke: ${colors.black.DEFAULT};
  }
`;

export const stop = (active: boolean) => css`
  fill: ${colors.gray[9]};

  ${active && 'filter: drop-shadow(0px 0px 8px rgba(119, 163, 211, 0.4));'}
`;

export const incident = (isPlugged: boolean) => css`
  fill: ${isPlugged ? colors.success[9] : colors.warning[9]};
`;

export const hintWrapper = css`
  background-color: ${colors.secondary.DEFAULT};
  border-radius: 5px;
  display: flex;
  max-width: fit-content;
  margin-top: -67px;
  margin-bottom: 40px;

  > span {
    margin: 5px 10px;
    color: ${colors.white.DEFAULT};
  }

  :after {
    content: "";
    position: absolute;
    border-width: 6px;
    border-style: solid;
    border-color: transparent ${colors.secondary.DEFAULT} transparent
      transparent;
    transform: rotate(-90deg);
    top: -40px;
    left: 9px;
  }
`;

export const incidentContentAction = css`
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid ${colors.gray[4]};
`;
